<template>
  <section class="timeline">
    <div class="intro">
      <headline kicker="Jahresrückblick" headline="Unsere Meilensteine 2020" color="white" />
      <p>In unserer Chronik blicken wir auf die spannendsten Zahlen und Fakten des vergangenen Geschäftsjahres zurück.</p>
    </div>
    <div class="items">
      <div class="line vertical bottom">
        <timeline-hero
          date="21. Januar"
          description="Effizienz und Klimaschutz: enercity-Studie zeigt Erwartungen der Menschen an die Smart City"
          image1="hero-01-1.jpg"
          image2="hero-01-2.jpg"
          type="hero-01"
          link="https://www.enercity.de/presse/pressemitteilungen/2020/Studie-Smart-City"
        />
      </div>
      <div class="line horizontal bottom">
        <timeline-item date="11. Februar" link-position="left" description="Digitalisierung der Energiewirtschaft: enercity steigt beim Cloud-Software Unternehmen epilot ein" link="https://www.enercity.de/presse/pressemitteilungen/2020/epilot" />
        <timeline-item date="26. Februar" link-position="left" description="Strom aus der „Lad-terne“: enercity stellt neue E-Ladesäulen für Wohngebiete vor" link="https://www.enercity.de/presse/pressemitteilungen/2020/Laternenladen" />
      </div>
      <timeline-hero
        date="12. März"
        description="Zum Schutz von Kunden und Mitarbeitern: enercity ergreift COVID-19-Präventionsmaßnahmen"
        image1="hero-02-1.jpg"
        image2="hero-02-2.jpg"
        type="hero-02"
        link="https://www.enercity.de/presse/pressemitteilungen/2020/corona"
      />
      <div class="connector c1">
        <timeline-item date="9. April" align="right" description="Streetview für die Netzinfrastruktur: enercity startet digitale Erfassung des Versorgungsgebiets" link="https://www.enercity.de/presse/betrieb-und-baustellen/2020/cyclomedia" />
      </div>
      <div class="line horizontal top add-padding">
        <timeline-item date="20. April" description="#abstandsbruder: enercity lässt sein Heizkraftwerk in Linden für Social Distancing neu leuchten" link="https://www.enercity.de/presse/pressemitteilungen/2020/abstand" />
        <timeline-hero
          date="27. Mai / 22. Juni"
          description="Grünes Licht für Fernwärme aus Klärschlamm in Hannover"
          image1="hero-03-1.jpg"
          image2="hero-03-2.jpg"
          type="hero-03"
          link="https://www.enercity.de/presse/pressemitteilungen/2020/Zuschlag-KS"
        />
      </div>
      <div class="connector c2">
        <timeline-item date="26. Juli" align="right" description="enercity errichtet neue Ultra-Schnellladesäulen für E-Fahrzeuge" link="https://www.enercity.de/presse/pressemitteilungen/2020/DC-Finca" />
      </div>
      <div class="line horizontal bottom">
        <timeline-item date="13. August" description="Allianz für die Smart City: enercity steigt bei <span class='nowrap'>IoT-Software</span>-Spezialist digimondo ein" link="https://www.enercity.de/presse/pressemitteilungen/2020/Digimondo" />
        <timeline-hero
          date="3. September"
          description="enercity begleitet Sophienklinik auf dem Weg zum Smart Hospital"
          image1="hero-04-1.jpg"
          image2="hero-04-2.jpg"
          type="hero-04"
          link="https://www.enercity.de/presse/pressemitteilungen/2020/vernetztes-krankenhaus-enercity-begleitet-sophienklinik-auf-dem-weg-zum-smart-hospital"
        />
      </div>
      <div class="connector c3"></div>
      <div class="line horizontal top">
        <timeline-hero
          date="10. September"
          description="200 E-Ladestationen: enercity erhält Großauftrag von Aldi Süd"
          image1="hero-05-1.jpg"
          image2="hero-05-2.jpg"
          type="hero-05"
          link="https://www.enercity.de/presse/pressemitteilungen/2020/enercity-baut-e-ladestationen-fuer-aldi-sued"
        />
        <timeline-item date="22. September" align="top" description="Clever heizen dank künstlicher Intelligenz: Pilotprojekt zeigt CO<sub>2</sub>-Einsparpotenzial" link="https://www.enercity.de/presse/pressemitteilungen/2020/enercity-steigert-mit-kuenstlicher-intelligenz-energieeffizienz-und-foerdert-klimaschutz" />
        <timeline-item date="6. Oktober" description="Baubeginn: Immobilien&shy;dienst&shy;leister hanova errichtet die neue enercity-Konzernzentrale" link="https://www.enercity.de/presse/pressemitteilungen/2020/innovation" />
        <timeline-hero
          date="13. Oktober"
          description="enercity startet Energiemagazin #positiveenergie"
          image1="hero-06-1.jpg"
          image2="hero-06-2.jpg"
          type="hero-06"
          link="https://www.enercity.de/magazin"
        />
      </div>
      <div class="connector c4"></div>
      <div class="line horizontal bottom">
        <timeline-item date="25. November" description="Meilenstein der Verkehrswende: enercity weiht 1000. Ladepunkt in Hannover ein" link="https://www.enercity.de/presse/pressemitteilungen/2020/enercity-weiht-tausendsten-ladepunkt-an-hdi-zentrale-in-hannover-ein" />
        <timeline-hero
          date="3. Dezember"
          description="2030 ist Schluss: Kohleausstieg bei enercity nimmt Formen an"
          image1="hero-07-1.jpg"
          image2="hero-07-2.jpg"
          type="hero-07"
          link="https://www.enercity.de/magazin/unsere-welt/kohleausstieg-stoecken-enercity"
        />
      </div>
      <div class="connector c5"></div>
      <div class="line horizontal top">
        <timeline-hero
          date="7. Dezember"
          description="„Live on tape“: enercity veranstaltet fünf kostenlose Jazzkonzerte via Internet"
          image1="hero-08-1.jpg"
          image2="hero-08-2.jpg"
          type="hero-08"
          link="https://www.enercity.de/magazin/deine-stadt/sofakonzerte"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import Headline from "../elements/Headline";
  import TimelineItem from "../elements/TimelineItem";
  import TimelineHero from "../elements/TimelineHero";
  export default {
    name: "SectionTimeline",
    components: {TimelineHero, TimelineItem, Headline}
  }
</script>

<style scoped>
  .timeline {
    position: relative;
    display: flex;
    height: 100%;
    min-width: 3000px;
    align-items: center;
    justify-content: flex-start;
  }
  .intro {
    width: 320px;
    margin: 200px 400px 0 200px;
    color: white;
  }
  .items {
    display: flex;
    align-items: center;
    margin-bottom: 5vh;
    margin-right: 11vh;
    height: 32vh;
  }
  .line {
    position: relative;
    display: flex;
    background-color: white;
    white-space: nowrap;
  }
  .line.horizontal {
    padding: 0 10px;
    height: 3px;
    align-items: flex-start;
  }
  .line.vertical {
    height: auto;
    width: 3px;
    flex-direction: column;
    background: linear-gradient(180deg, rgba(255,255,255,0) 30%, rgba(255,255,255,1) 60%);
  }
  .line.bottom {
    align-self: flex-end;
  }
  .line.top {
    align-self: flex-start;
  }
  .connector {
    position: relative;
    height: 32vh;
    width: 3px;
    background-color: white;
    align-self: flex-end;
    padding-top: 10vh;
  }
  .c1:before {
    content: "";
    position: absolute;
    width: 70vh;
    height: 3px;
    bottom: 0;
    right: 0;
    background-color: white;
  }
  .c2 {
    padding-top: 7vh;
    height: 38vh;
    align-self: flex-start;
  }
  .c2 + .line {
    top: 6vh;
    padding-left: 10vh;
  }
  .c3 {
    top: 14vh;
    height: 24vh;
    align-self: flex-start;
  }
  .c3 + .line {
    margin-top: 14vh;
    align-items: flex-start;
  }
  .c4 {
    top: 14vh;
    height: 23vh;
    align-self: flex-start;
  }
  .c4 + .line {
    margin-bottom: -5vh;
    align-items: flex-start;
    padding: 0 3vh;
  }
  .c5 {
    top: 18vh;
    height: 19vh;
    align-self: flex-start;
  }
  .c5 + .line {
    margin-top: 18vh;
    align-items: flex-start;
    padding-left: 4vh;
    min-width: 600px;
    margin-right: 50px;
  }
  .c5 + .line:before, .c5 + .line:after {
    content: "";
    position: absolute;
    right: -1px;
    top: 0;
    bottom: 0;
    width: 20px;
    border-radius: 2px;
    background-color: #fff;
    transform-origin: 96% center;
    transform: rotate(-45deg);
  }
  .c5 + .line:after {
    transform: rotate(45deg);
  }
  .line.add-padding {
    padding-left: 320px;
  }
  @media(max-width: 999px) {
    .timeline {
      min-width: 0;
      max-width: 100%;
      flex-direction: column;
      height: auto;
    }
    .intro {
      margin: 80px 20px 30px;
    }
    .items {
      overflow-x: auto;
      width: 100vw;
      padding: 0 0 0 230px;
      margin: 0 -20px calc(15vw + 40px);
      overflow-y: hidden;
      height: 500px;
    }
    .items:after {
      content: "xxx";
      position: relative;
      display: block;
      min-width: 10px;
      opacity: 0;
    }
    .line.horizontal {
      height: 2px;
      margin-bottom: 220px;
    }
    .line.vertical {
      width: 2px;
      margin: 220px 0;
    }
    .connector {
      min-width: 2px;
      padding-top: 0;
    }
    .c1 {
      height: 220px;
      padding-top: 73px;
      margin-bottom: 220px;
    }
    .c1:before {
      height: 2px;
      width: 450px;
    }
    .c1 + .line.horizontal {
      margin-top: 60px;
      padding-left: 230px;
    }
    .c2 {
      margin-top: 60px;
      height: 210px;
      padding-top: 30px;
    }
    .c2 + .line.horizontal {
      margin-bottom: 230px;
      top: auto;
    }
    .c3 {
      height: 90px;
      top: 180px;
    }
    .c3 + .line.horizontal {
      margin-top: 180px;
    }
    .c4 {
      top: 0;
      margin-top: 180px;
      height: 100px;
    }
    .c4 + .line.horizontal {
      padding-left: 0;
    }
    .c5 {
      top: 180px;
      height: 100px;
    }
    .c5 + .line.horizontal {
      margin-top: 180px;
      padding-right: 200px;
      padding-left: 20px;
      min-width: 640px;
    }
  }
  @media(max-width: 999px) and (min-width: 568px) {
    .intro {
      margin: 180px auto 50px;
      width: 540px;
    }
    .items {
      margin-bottom: calc(18vw + 40px);
      padding-left: 300px;
    }
  }
</style>